import React, {forwardRef, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import {KeyboardArrowDown, Settings} from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import {containedButton} from "../../../utils/styles";

const useStyles = options => makeStyles(theme => ({
    ...containedButton(theme, false, false),
    paper: {
        maxWidth: 300,
        backgroundColor: options.menuColor ? options.menuColor : 'white',
        color: options.fontColor ? options.fontColor : 'inherit'
    },
    iconButton: {
        margin: 0,
        color: options.iconButtonColor ? options.iconButtonColor : 'rgba(0, 0, 0, 0.54)',
        '& svg': {
            //fontSize: '2.4rem'
        }
    },
    listItem: {
        minHeight: 'auto'
    },
    listItemIcon: {
        display: 'inline-flex',
        minWidth: '56px',
        flexShrink: 0
    }
}));

const MenuItemCustomized = forwardRef((props, ref) => {
    const {label, icon: Icon, onClick} = props;
    const classes = useStyles({})();

    return (
        <MenuItem
            className={classes.listItem}
            onClick={onClick}
            {...props}>
            {Icon && (
                <div className={classes.listItemIcon}>
                    <Icon/>
                </div>
            )}
            <Typography
                variant='inherit'
                dangerouslySetInnerHTML={{__html: label}}/>
        </MenuItem>
    );
});

export default function SimpleMenu(props) {
    const {
        icon: Icon = Settings,
        iconButton = false,
        label = 'Opções',
        iconButtonColor,
        namedButton = false,
        menuColor,
        fontColor,
        menuVerticalDistance = -50,
        options,
        ...rest
    } = props;
    const classes = useStyles({
        menuColor,
        fontColor,
        iconButtonColor
    })();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickMenuItem = onClick => () => {
        onClick && onClick();

        handleClose();
    };

    return (
        <>
            {namedButton ? (
                <Button
                    className={classes.containedButton}
                    variant="contained"
                    endIcon={<KeyboardArrowDown/>}
                    aria-controls={`${label}Label`}
                    aria-haspopup="true"
                    onClick={handleClick}
                    {...rest}>
                    {label}
                </Button>
            ) : (
                <>
                    {!iconButton ? (
                        <Button
                            startIcon={<Icon/>}
                            endIcon={<KeyboardArrowDown/>}
                            aria-controls={`${label}Label`}
                            aria-haspopup="true"
                            onClick={handleClick}
                            {...rest}>
                            {label}
                        </Button>
                    ) : (
                        <IconButton
                            onClick={handleClick}
                            aria-label="Opções"
                            className={classes.iconButton}
                            {...rest}>
                            <Icon/>
                        </IconButton>
                    )}
                </>
            )}
            <Menu
                id={`${label}Label`}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                transformOrigin={{vertical: menuVerticalDistance, horizontal: 'right'}}
                onClose={handleClose}
                classes={{paper: classes.paper}}>
                {options.map(option => (
                    <MenuItemCustomized
                        key={option.label}
                        label={option.label}
                        icon={option.icon}
                        onClick={handleClickMenuItem(option.onClick)}
                        disabled={option.disabled}/>
                ))}
            </Menu>
        </>
    );
}

SimpleMenu.propTypes = {
    iconButton: PropTypes.bool,
    icon: PropTypes.elementType,
    label: PropTypes.string,
    options: PropTypes.array.isRequired,
    namedButton: PropTypes.bool
};